import { useShallow } from 'zustand/shallow'

import { useStore } from '@app/store'

const useGetIsSelecting = (): boolean => useStore(useShallow((state) => state.isSelecting))

export default useGetIsSelecting
